import { createAction } from 'Lib/reduxUtils';

import { LOAD_INTL_MESSAGES_SUCCESS } from './constants';
import type { IntlMessagesState } from './types';

export const loadIntlMessageSuccess = createAction(
  LOAD_INTL_MESSAGES_SUCCESS,
  (messages: IntlMessagesState) => messages
);
